import { TargetDomEvent } from 'aws-rum-web';
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { CookieConsentContext } from '../../contexts/CookieConsentContext';
import { EnvironmentConfig } from '../../Environments';
import RumClient, { RumEvent } from './RumClient';
import { DOMRegisteredEvents } from './RumConstants';

export type RegisterDomEvents = (events: TargetDomEvent[]) => void;
export type RecordEvent = (event: RumEvent) => void;

const registerDomEvents: RegisterDomEvents = events => RumClient.registerDomEvents(events);
const recordEvent: RecordEvent = event => RumClient.recordEvent(event);

export const RumManager = (env: EnvironmentConfig): {registerDomEvents: RegisterDomEvents, recordEvent: RecordEvent} => {

    const { cookie } = useContext(CookieConsentContext);
    const [ hasPerfCookieConsent, setHasPerfCookieConsent ] = useState(cookie.performance);
    RumClient.init(env);

    /* Register DOM events for RUM interaction telemetry.
       Refer list for valid DOM Events. https://www.w3schools.com/jsref/dom_obj_event.asp 
    */ 
    useEffect(() => {
        RumClient.registerDomEvents(DOMRegisteredEvents);
    }, []);

    // Only enable cookies if perf cookie enabled
    useEffect(() => {
        if (cookie.performance !== hasPerfCookieConsent) {
            setHasPerfCookieConsent(cookie.performance);
            RumClient.enableCookies(cookie.performance);
        }
    }, [cookie, hasPerfCookieConsent]);

    // Manually record page views to merge out unique pages
    const location = useLocation();
    useEffect(() => {
        RumClient.recordPageView(filterPageView(location.pathname));
    }, [location]);

    return {
        registerDomEvents,
        recordEvent
    };
};

// Create list of filters that remove unique IDs in the URL path
// Ensure new filters are placed in order otherwise pattern matching may not work
// due to previous substitutions
export const filterPageView = (path: string): string => {
    let result = path;

    // Filter UIDs from the URL path
    result = result.replace(RegExp('\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}', 'gi'), '\/UUID');

    return result;
};
